import React, { useState, useEffect } from 'react';
import { useNavigation } from '../../../context/NavigationContext';
import {
	BringzzPageContainer,
	BringzzIcon,
	BringzzText,
} from '@bringzz/components';
import useUser from '../../../hooks/useUser';
import useRequest from '../../../hooks/useRequest';
import { useTranslation } from 'react-i18next';

const PharmacyInfo = () => {
	const { t } = useTranslation();
	const { backPress, navigate } = useNavigation();
	const { getUser } = useUser();
	const { sendRequest } = useRequest();
	const user = getUser();

	const [integrationId, setIntegrationId] = useState(null);

	const pharmacistFields = [
		{ name: t('component.pharmacy_info.view_profile'), key: 'view_profile', icon: 'IconPharmacy', folder: 'HealthIcons' },
		{ name: t('component.pharmacy_info.address'), key: 'address', icon: 'IconHospitalLocation' },
		{
			name: t('component.pharmacy_info.opening_hours'),
			key: 'opening_hours',
			path: 'opening',
			icon: 'IconClockAlt1'
		},
		{ name: t('component.pharmacy_info.night_duties'), key: 'night_duties', path: 'duties', icon: 'IconClockAlt1' },
	];

	const [fields, setFields] = useState([]);

	useEffect(() => {
		const fetchPharmacyInfo = async () => {
			try {
				const response = await sendRequest({
					method: 'GET',
					url: `/module/profile/getPharmacyInfo`,
				});
				if (response.status === 'success') {
					setIntegrationId(response.data.integration_id);
				}
			} catch (error) {
				console.error('Error fetching pharmacy info:', error);
			}
		};

		if (user) {
			fetchPharmacyInfo();
            setFields(pharmacistFields);
		}
	}, [user]);

	return (
		<BringzzPageContainer
			header={{
				left: (
					<BringzzIcon
						size='22'
						icon='IconChevronLeft'
						folder='LineIcons'
						className='cursor-pointer'
						onClick={backPress}
					/>
				),
				title: <BringzzText tag='h2'>{t('component.pharmacy_info.title')}</BringzzText>
			}}
		>
			<div className='p-4'>
				{fields.map((field, index) => (
					<div
						key={index}
						className='flex items-center justify-between cursor-pointer  py-4'
						onClick={() => {
					if (field.key === 'view_profile' && integrationId) {
						navigate(`/pharmacy/profile/${integrationId}`);
					} else if (field.key === 'address') {
						navigate(`/Address`);
					}
					else if (field.path) {
						navigate(`/settings/pharmacy/info/${field.path}`);
					}
				}}
					>
						<div className='flex flex-row items-center '>
                            <div className='items-center' >
                            <BringzzIcon size='22' icon={field.icon} folder={field.folder || 'LineIcons'} />

                                </div>
                                <div className='items-center'>
                                <BringzzText className={"px-4"} tag='h3'>{field.name}</BringzzText>

                                </div>		
						</div>
						<BringzzIcon size='22' icon={'IconArrowRight'} folder={'LineIcons'} />
					</div>
				))}
			</div>
		</BringzzPageContainer>
	);
};

export default PharmacyInfo;
